<template>
<div id="app">
  <!--
  <div style="position:fixed; top:200px; left:200px">
    <input type="range" v-model="scrollSpeed" min="0" max="90" />
    speed
  </div>
    <div style="position:fixed; top:400px; left:200px">
      <input type="range" v-model="endDelay" min="0" max="100" />
      delay
    </div>
    -->
  <div id="topContent">
    <h1>Electrify Everything</h1><br/>
    <h3>Saul Griffith and Sam Calisch</h3><br/>
    <i>Stop using fossil fuels and make money for every American household</i>

    <br/><br>
    <div id="intro">
    Many people want to do something personal to contribute to climate solutions, but don’t know what that is. In this project, we detail the process of decarbonizing a household and use historical data and current technology to build a cost model for the process.
    What we learn is that if we do it right — without any heroic new technology — we can start saving thousands of dollars per household, and billions of dollars per state, every year, while addressing almost half of U.S. greenhouse gas emissions.<br/><br/><br/>
    Scroll to see how we can electrify, today.<br/><br/><br/><br/><br/>
    V
    
    </div>
  </div>
  <MainScroller id="scroller" />
  <div class="section-header"> </div>
  <h1 style="margin-top: 20vh">Let's electrify today. <br> It's the stimulus that pays for itself.</h1>

  <br>

  <h2> Want to know more? </h2>

  <p><a href='https://www.rewiringamerica.org/household-savings-report'>Read the report.</a></p>
  <p><a href='https://www.rewiringamerica.org/handbook'>Read the handbook.</a></p>
  <p><a href='https://www.rewiringamerica.org/volunteers'>Join the effort.</a></p>


  <div class="spacer-bottom"/>
</div>

</template>

<script>
import MainScroller from '@/components/MainScroller'
export default {
  name: 'App',
  components: { MainScroller },
  data(){
    return {
      scrollSpeed: 50,
      endDelay: 50
    }
  },
  methods:{

  },
  mounted(){
    let root = document.documentElement;
    root.style.setProperty('--scrollSpeed', 100-this.scrollSpeed);
    root.style.setProperty('--endDelay', this.endDelay);
  },  
  watch:{
    scrollSpeed(newval){
      let root = document.documentElement;
      root.style.setProperty('--scrollSpeed', 100-newval);
    },
    endDelay(newval){
      let root = document.documentElement;
      root.style.setProperty('--endDelay', newval);
    }

  },
  metaInfo: {
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1.9' }
    ]
  }
}
</script>

<style lang="scss">
  
.scrollama-graphic div{
  z-index: 100;
}

.scrollama-container {
  z-index: -100;
}

* {
    margin:0;
    padding:0;
    box-sizing:border-box;
}

#app {    
    display: flex;
    flex-direction: column;
    min-height: 100vh;    
    max-width:100vw;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    box-sizing:border-box!important;
    font-size:calc(min(2.5vh,32px));
}

#scroller{
}

#title{
    padding-bottom:4vh;
}

#intro {    
    margin: 0 auto!important;
    width: 90vw;
    min-height: 20vh;    
    padding-bottom:20vh;
}

.section-header {
  background-color: #1e2343;
  color: white;
  font-size: calc(min(2.5vh,32px));
  padding-top:.1vh;
  height:3.5vh;
}

.spacer-bottom {
    height: 66vh;
}

.graphicContainer{
    padding-top:3vh;
}

.graphic {
    max-height: 80vh;
}

.customstep {
    height: calc(100vh);

    z-index:-1000;
}

.filler{
    height: calc(100vh);
}


.fast{
    height:40vh!important;
}

  


</style>
